import { Constants } from "../ENVIROMENT_VARIABLES";

const branches_form = $('#branches_form');
const branches_map = $('#map');
var Temp_Token=JSON.parse(sessionStorage.getItem('TP_Token'));

$(function(){
  $("#loading-overlay").show();


    // EVENT HANDLER
    // On change city selection
    // branches_form.find('select').on('change', (e) => {
    //     e.preventDefault();
    //     const selectedCityId = $(e.currentTarget).val();
    //     // console.log(selectedCity);
    //     if( selectedCityId !== '0' ){
    //         branches_list.removeClass('active');
    //         for( let i=0; i < branches_list.length; i++ ){
    //             let currentBranchCity = branches_list.eq(i).attr('data-cityId');
    //             currentBranchCity === selectedCityId && branches_list.eq(i).addClass('active');
    //         }
    //     }else{
    //         branches_list.addClass('active');
    //     }
        
    //     activeFirstBranchOnMap();
    // });

    //CALLING API TO RETURN BRANCHES

    // API CALLING FOR BRANCH LIST
  $.ajax({
    type: "POST",
    url:`${Constants.BASE_URL}thirdParty/getBranches.srvc?method=POST`,
    headers: {
        'Accept': 'application/json',
        'Content-Type':'application/json',
        'Data-Type': 'json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': 'Content-Type , Authorization',
        'Access-Control-Allow-Credentials': 'true',
        'Authorization': `Bearer ${Temp_Token.Token}`
    },
    success: function (data) {
      var languageKey = getLanguageFromLocalStorage();

      $("#loading-overlay").hide();

      for(let i=0; i<data.length; i++){
        let locationArray=(data[i].latitudeLongitude).split(",");
        let latitude=locationArray[0];
        let longitude=locationArray[1];
        $('#branches-container').append($(`
       
        
      <div class="branch card-container col-10 col-sm-6 col-lg-4 m-auto" data-cityId="${data[i].rid}">
          <div class="card h-100 pt-2">
            <div class="card-body d-flex flex-row-reverse">
            
                <div class="text-container px-3 py-3">
                    <h5 class="card-title" style="color: var(--dark-green)">${data[i].name[languageKey]}</h5>
                    <!--<div class="details-group">
                        <p class="card-text">Makkah</p>
                    </div> -->
                    <div class="details-group">
                        <h6 class="card-subtitle" data-i18n-key="address">Address</h6>
                        <p class="card-text" style="min-height: 45px"> ${data[i].address[languageKey]}</p>
                    </div>
                    <div class="details-group">
                    <h6 class="card-subtitle">Phone</h6>
                    <p class="card-text"><a href="tel:${data[i].phoneNo}">${data[i].phoneNo}</a></p>
                    <p class="card-text"><a href="tel:${data[i].mobileNo}">${data[i].mobileNo}</a></p>
                  </div>
                  <div class="details-group">
                    <h6 class="card-subtitle">Fax</h6>
                    <p class="card-text"><a href="mailto:${data[i].faxNo}">${data[i].faxNo}</a></p>
                  </div>
                    <div class="row">
                        <div class="col-12 col-sm-7">
                            <div class="details-group">
                                <h6 class="card-subtitle" data-i18n-key="working-days">Working days</h6>
                                <p class="card-text py-0 mb-1">Saturday - Thursday</p>
                            </div>
                        </div>
                        <div class="col-12 col-sm-5">
                            <div class="details-group">
                                <h6 class="card-subtitle" data-i18n-key="opening-hours">Opening hours</h6>
                                
                                <p class="card-text py-0 mb-1">${data[i].workingHours}</p>

                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="details-group mt-3 location-container">
                      <h6 class="card-subtitle" data-i18n-key="location">Location</h6>
                      <button type="button" class="btn btn-lg view-location-btn" data-location="https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}"
                 data-map="https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed">
                  <i class="fas fa-map-marked-alt"></i>
                </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        
        `
        ));
        $('#branches-container').on('click', '.view-location-btn', (e) => {
          const location = $(e.currentTarget).attr('data-location');
          const map = $(e.currentTarget).attr('data-map');
          const card = $(e.currentTarget).parents('.card');
          const branches_list = $('#branches .branches-wrapper .branch');
          
          branches_map.find('iframe').attr('src', map);
          branches_map.find('.open-map-btn').attr('href', location);
          branches_map.addClass('active');
          branches_list.find('.card').removeClass('active');
          card.addClass('active');
          window.scrollTo({
              top: document.querySelector('#map').offsetTop,
              behavior: "smooth"
            })
      });
      }
    },

  });

    //EVENT HANDLER
    // On click branch view map button
    $('#branches-container').on('click', '.view-location-btn', (e) => {
        const location = $(e.currentTarget).attr('data-location');
        const map = $(e.currentTarget).attr('data-map');
        const card = $(e.currentTarget).parents('.card');
        const branches_list = $('#branches .branches-wrapper .branch');

        branches_map.find('iframe').attr('src', map);
        branches_map.find('.open-map-btn').attr('href', location);
        branches_map.addClass('active');
        branches_list.find('.card').removeClass('active');
        card.addClass('active');
        window.scrollTo({
            top: document.querySelector('#map').offsetTop,
            behavior: "smooth"
          })
    });

    // Activate the first branch map
    // function activeFirstBranchOnMap(){
    //     $('#branches .branch.active').eq(0).find('.card').addClass('active');
    //     $('#branches .branch.active').eq(0).find('.view-location-btn').trigger('click');
    // }

    // ON PAGE LOAD EVENT
    // branches_list.removeClass('active');
    // branches_map.removeClass('active');
    // const selectedCityId = branches_form.find('select').val();
    // if( selectedCityId !== '0' ){
    //     for( let i=0; i < branches_list.length; i++ ){
    //         let currentBranchCity = branches_list.eq(i).attr('data-cityId');
    //         currentBranchCity === selectedCityId && branches_list.eq(i).addClass('active');
    //     }
    // }else{
    //     branches_list.addClass('active');
    // }
    // activeFirstBranchOnMap();
    
});


function getLanguageFromLocalStorage() {
  // Retrieve the language value from localStorage
  const language = localStorage.getItem('i18n');

  // Default language if not found in localStorage
  const defaultLanguage = 'en_us';

  // Return the corresponding key based on the language value
  switch (language) {
    case 'ar':
      return 'ar_jo';
    case 'en':
      return 'en_us';  
    // Add more cases for other languages if needed
    default:
      return defaultLanguage;
  }
}
